<template>
  <div class="container">
    <transition :css="false">
      <el-dialog
        title=""
        :visible.sync="showModal"
        :before-close="gotoFeedback"
        width="30%"
      >
        <div class="heading">
          <h2 class="login-title">Process Payment</h2>
        </div>
        <form>
          <arnergy-input label="First name" :model="firstName" />
          <arnergy-input :model="lastName" label="Last name" />
          <arnergy-input label="Email" :model="email" />

          <label class="text-dark">Amount</label>
        </form>
        <div class="paying-now">
          <span>Paying now</span>
          <span>
            NGN{{ (productAmt + "").replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") }}
          </span>
        </div>

        <!-- real footer item -->
        <button @click="flutterwavePaygate" class="submit-button" type="button">
          Make Payment
        </button>
        <div class="footer-lock">
          <i class="fa fa-lock"></i>
          <small class="small">
            Payment are encrypted using 256-bit SSL
          </small>
        </div>
        <p class="space small">
          By clicking
          <span>"Make Payment"</span>
          you acknowledge that you have read and agree to our
          <a class="link" href="#">Terms of Use</a>
          and
          <a class="link" href="#">Privacy Policy</a>
          ; you will e charged the same price every 12months untill you cancel
          your membership or complete payment. You may cancel subscription by
          accessing Account settings section on your dashboard.
        </p>
      </el-dialog>
    </transition>
    <transition :css="false">
      <el-dialog title="" :visible.sync="errorStatus" width="30%">
        <div class="heading">
          <h2 class="login-title text-danger">Error</h2>
        </div>
        <p class="text-danger text-center">Email or username already exists</p>
      </el-dialog>
    </transition>
    <transition :css="false">
      <el-dialog title="" :visible.sync="required" width="30%">
        <div class="heading">
          <h2 class="login-title text-danger">Error</h2>
        </div>
        <p class="text-danger text-center">All fields are required!</p>
      </el-dialog>
    </transition>
    <transition :css="false">
      <el-dialog title="" :visible.sync="passwordMatch" width="30%">
        <div class="heading">
          <h2 class="login-title text-danger">Error</h2>
        </div>
        <p class="text-danger text-center">Passwords do not match!</p>
      </el-dialog>
    </transition>

    <Rave
      style="display: none;"
      :is-production="true"
      text="Pay Now"
      style-class="btn btn-primary"
      id="paymentbtn"
      :email="email"
      :amount="500"
      :reference="genRandomNumber"
      :rave-key="raveKey"
      :callback="callback"
      :redirectUrl="redirectUrl"
      :metadata="meta"
      paymentOptions="card,barter,account,ussd"
      :payment_plan="parseInt(0)"
      :close="close"
      currency="NGN"
      :customerFirstname="firstName"
      :customerLastname="lastName"
      :customerPhone="phone_number"
    ></Rave>

    <vk-offcanvas flipped overlay stuck :show.sync="showOffCanvas">
      <!-- {{packageConfigs}} -->
      <div>
        <vk-offcanvas-close @click="showOffCanvas = false"></vk-offcanvas-close>
        <h3>Payment</h3>
        <hr />
      </div>
    </vk-offcanvas>
    <div class="col-xl-12 col-lg-5 col-md-5 offset-4">
      <!-- <div
        class="page-content__header-description"
        style="display: flex; margin-bottom: 20px;"
      >
        <h2 style="flex: 1;">Payment Process</h2>
      </div> -->
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12">
          <div class="container-fluid">
            <div class="heading mb-5">
              <h2 class="login-title">Create an account to complete payment</h2>
              <p>
                Monitor your device. Save mother Earth. Build an eco-friendly
                environment. Do it all with Arnergy Solar. Already have an
                account?
                <span
                  ><router-link class="link" to="/auth/login"
                    >Log in</router-link
                  ></span
                >
              </p>
            </div>
            <form>
              <p v-if="passwordMatch" class="text-danger text-center">
                Password and confirm password do not match
              </p>
              <p v-if="required" class="text-danger text-center">
                All fields are required!
              </p>

              <arnergy-input label="First name" v-model="firstName" />
              <arnergy-input v-model="lastName" label="Last name" />
              <arnergy-input label="Email" v-model="email" />
              <arnergy-input label="Phone Number" v-model="phone_number" />
              <div class="form-item">
                <label class="label">Password</label>
                <input
                  type="password"
                  class="input"
                  placeholder="Password"
                  v-model="password"
                  required
                />
              </div>
              <div class="form-item">
                <label class="label">Confirm Password</label>
                <input
                  type="password"
                  class="input"
                  placeholder="Confirm Password"
                  v-model="cpassword"
                  required
                />
              </div>

              <arnergy-select
                v-model="customerType"
                label="Customer Type"
                :items="CT"
              />
            </form>

            <!-- real footer item -->
            <button @click="flutterwavePay" class="submit-button" type="button">
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Users from "../users/index";
import Rave from "vue-ravepayment";
import Devices from "../devices/List";
import transactionHistories from "../shs/Wallet";
import ArnergyInput from "../kitchen/ArnergyInput";
import ArnergySelect from "../kitchen/ArnergySelect.vue";
import axios from "axios";
import userRole from "../users/allow";
import ModalVerify from "../kitchen/Onboarding/modal-verify.vue";
import Vue from "vue";
import router from "../../../router";
import ModalSuccess from "../kitchen/Onboarding/ModalSuccess.vue";
import {
  Select,
  Button,
  Autocomplete,
  Dialog,
  Form,
  FormItem,
  Radio,
  RadioGroup,
  RadioButton
  // ...
} from "element-ui";
import { Offcanvas, OffcanvasClose } from "vuikit/lib/offcanvas";
import { mapActions } from "vuex";
export default {
  name: "",
  components: {
    "vk-offcanvas": Offcanvas,
    "vk-offcanvas-close": OffcanvasClose,
    "el-autocomplete": Autocomplete,
    "el-form": Form,
    "el-form-item": FormItem,
    "el-radio": Radio,
    "el-radio-group": RadioGroup,
    "el-radio-button": RadioButton,
    Users,
    "el-dialog": Dialog,
    ArnergyInput,
    ArnergySelect,
    Devices,
    transactionHistories,
    Rave,
    ModalSuccess,
    ModalVerify,
    userRole
  },
  data() {
    return {
      showOffCanvas: false,
      passwordMatch: false,
      errorStatus: false,
      connectionStatus: false,
      activeTab: "user_list",
      CT: [
        { id: "Individual", name: "Customer Individial" },
        { id: "Corporate", name: "Customer Corporate" }
      ],
      usertype: localStorage.roleType,
      firstName: "",
      lastName: "",
      raveKey: "FLWPUBK-fc3e5bbcb014dba6aea1724614daa1d5-X",
      email: "",
      phone_number: "",
      showModal: false,
      productAmt: "",
      customerType: "",
      password: "",
      required: false,
      redirectUrl: "https://solarbase.arnergy.com/auth/paymentFeedback",
      cpassword: "",
      modalSucess: false,
      meta: [
        {
          metaname: "school",
          metavalue: "high school"
        }
      ],
      ModalVerify: false
    };
  },
  computed: {
    genRandomNumber() {
      let text = "";
      let possible =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (let i = 0; i < 5; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      text += Math.round(new Date().getTime() / 1000);
      return text;
    }
  },
  methods: {
    ...mapActions(["saveOsCustomer"]),
    flutterwavePay() {
      const data = {
        firstName: this.firstName,
        email: this.email,
        roleType: this.customerType,
        ccEmails: this.email,
        assignedDevices: "null",
        lastName: this.lastName,
        dateOfBirth: new Date(),
        phoneNumber: this.phone_number,
        gender: 0,
        street_route: "string",
        wallet: 0,
        createdAt: "2021-07-09T11:17:55.049Z",
        updatedAt: "2021-07-09T11:17:55.049Z",
        realm: "string",
        username: this.email,
        emailVerified: true,
        password: this.password
      };

      if (
        this.firstName &&
        this.lastName &&
        this.email &&
        this.phone_number &&
        this.password &&
        this.cpassword
      ) {
        const HTTP = this.$httpUtils.instance;
        if (this.cpassword && this.password) {
          HTTP.post(`/users`, data)
            .then(res => {
              if (res.data.id) {
                this.showModal = true;
                console.log(res.data);
                this.saveOsCustomer(res.data);
                localStorage.firstName = res.data.firstName;
                localStorage.lastName = res.data.lastName;
                localStorage.customerId = res.data.id;
                localStorage.phoneNumber = res.data.phoneNumber;

                this.showLoading = false;

                HTTP.patch("/onboardingStates", {
                  customerid: res.data.id,
                  packageType: "OS",
                  stateid: 1
                }).then(x => {
                  localStorage.customerState = x.data.id;
                  localStorage.packageType = x.data.packageType;
                  this.$store.commit("saveOnboanrdingState", 1);
                });

                HTTP.post(
                  "/onboardingNotifications/sendAccountRegistrationEmail",
                  {
                    firstName: res.data.firstName,
                    lastName: res.data.lastName,
                    email: res.data.email
                  }
                );
              } else {
                this.errorStatus = true;
                setTimeout(() => {
                  this.errorStatus = false;
                }, 2000);
              }
            })
            .catch(Err => {
              this.errorStatus = true;
              setTimeout(() => {
                this.errorStatus = false;
              }, 2000);
            });
        } else {
          this.passwordMatch = true;
          setTimeout(() => {
            this.passwordMatch = false;
          }, 2000);
        }
      } else {
        this.required = true;
        setTimeout(() => {
          this.required = false;
        }, 2000);
      }
    },
    callback: function(response) {
      let trRef = response.data;
      trRef.data = trRef.tx == undefined ? trRef.data : trRef.tx;
      this.close();
      // @todo: validate request... this is wrong
      if (trRef.data.status === "successful") {
        this.showSuccessMsg = { message: "Transaction Successful" };
        // console.log('yeeeeeeeeeeeeeeeeeeeeeeeee')
        // this.gotoSection(1)
      } else {
        this.showErrorMsg({ message: "Transaction fails" });
      }
    },
    triggerPayment() {
      document.getElementById(`paymentbtn`).click();
    },
    close() {
      console.log("Payment closed");
    },
    gotoFeedback() {
      const customer = {
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        phone_number: this.phone_number,
        productAmt: this.productAmt,
        customerType: this.customerType,
        usertype: localStorage.roleType
      };
      this.saveOsCustomer(customer);
      router.push("/auth/paymentFeedback");
    },
    flutterwavePaygate() {
      FlutterwaveCheckout({
        public_key: "FLWPUBK-fc3e5bbcb014dba6aea1724614daa1d5-X",
        tx_ref: this.genRandomNumber,
        amount: this.productAmt,
        currency: "NGN",
        country: "NG",
        paymentType: "account",

        // specified redirect URL
        redirect_url: "https://solarbase.arnergy.com/auth/paymentFeedback",
        meta: {
          consumer_id: 23,
          consumer_mac: "92a3-912ba-1192a"
        },
        customer: {
          email: this.email,
          phone_number: this.phone_number,
          name: this.firstName + " " + this.lastName
        },
        callback: function(data) {
          console.log(data);
        },
        onclose: function() {
          // close modal
        },
        customizations: {
          title: "Arnergy Solar",
          description: "Payment",
          logo: "https://arnergy.com/wp-content/uploads/2020/07/Arnergy.svg"
        }
      });
    },

    getParamValuesByName(querystring) {
      var qstring = window.location.href
        .slice(window.location.href.indexOf("?") + 1)
        .split("&");
      for (var i = 0; i < qstring.length; i++) {
        var urlparam = qstring[i].split("=");
        if (urlparam[0] == querystring) {
          return urlparam[1];
        }
      }
    },
    async fetchProductById(id) {
      const HTTP = this.$httpUtils.instance;
      let res = await HTTP.get(`/arnergyProducts/${id}`);

      if (res.data) {
        this.productAmt = res.data.amountOS;
      }
    }
  },
  async mounted() {
    var uid = this.getParamValuesByName("id");
    this.fetchProductById(uid);
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/_reduced_variables.scss";

.parent-box {
  position: relative;
}

.heading {
  text-align: center;
  margin: auto;
  max-width: 550px;
}

.link {
  color: $primary-color;
  font-weight: bold;
}

.login-title {
  // margin-bottom: 40px;
  font-weight: 900;
  font-size: 32px;
  // color: $primary-color;
}

.space {
  margin: 20px 0;
  margin-left: 20px;
  color: #8f8d8c;

  span {
    color: black;
    font-weight: bold;
  }
}

.misbehave {
  margin: 50px auto 20px auto;
  max-width: 550px;
}

.checkbox-style {
  display: flex;
  // align-items: center;

  input,
  p {
    margin-right: 5px;
  }

  p {
    margin: 0;
  }
}

.packages {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  div {
    margin: 10px;
  }
}

.footer {
  margin: 50px auto;
  max-width: 550px;
}

.flex {
  display: flex;
  align-items: center;

  > :first-child {
    margin-right: 5px;
  }
}

.intro-title {
  text-align: center;
  position: relative;

  .text {
    font-weight: bold;
    position: relative;
    z-index: 10;
    display: inline;
    background: #f9f9f9;
    padding: 0 20px;
  }

  &:before {
    width: 100%;
    height: 2px;
    background: #ebebeb;
    display: block;
    content: "";
    position: absolute;
    top: 10px;
    z-index: 0;
    // bottom: 0;
  }
}

.form-item {
  margin: 10px 0;

  label {
    margin-bottom: 10px;
    color: #999;
    font-size: 14px;
    padding: 0;
    font-weight: bold;
    display: block;
    text-align: left;
  }

  .select-input {
    border: 1px solid #cccccc;
    width: 100%;
    padding: 10px 20px;
    height: 50px;
  }

  input,
  .input {
    border-radius: 5px;
    width: 100%;
    display: block;
    background: white;
    padding: 20px;
    border: 1px solid #f4f4f4;
  }
}

.paying-now {
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 1px solid #ebebeb;
  padding: 10px 0;
  font-size: 24px;

  span {
    color: black;
    font-weight: bold;
  }

  span:first-child {
    font-size: 12px;
    margin-right: 10px;
  }
}

.footer-lock {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px 0;

  .small {
    font-weight: bold;
    margin-left: 5px;
    color: black;
  }
}

.submit-gif {
  display: block;
  color: white;
  width: 100%;
  text-align: center;
  color: white;
  padding: 15px 32px;
  margin-top: 20px;
  border: 0;
  background-color: $secondary-color;
}

.submit-button {
  display: block;
  color: white;
  width: 100%;
  text-align: center;
  padding: 15px 32px;
  margin-top: 20px;
  border: 0;
  background-color: $secondary-color;
  font-weight: bold;

  &:hover {
    background-color: darken($secondary-color, 10%);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/payment/paymentProcess.vue